export var CategoryNamespace;
(function (CategoryNamespace) {
    CategoryNamespace["PROCESSING_FLOW"] = "processing-flow";
    CategoryNamespace["PROCESSING_VOICE"] = "processing-voice";
    CategoryNamespace["EXECUTABLE_GENERAL"] = "executable-general";
    CategoryNamespace["EXECUTABLE_LLM"] = "executable-llm";
    CategoryNamespace["EXECUTABLE_PORT_IN_IDENTIFIER"] = "executable-port-in-identifier";
    CategoryNamespace["LOOKUP"] = "lookup";
    CategoryNamespace["TELEPHONY_VOICE"] = "telephony-voice";
    CategoryNamespace["MESSAGING_TEXT"] = "messaging-text";
    CategoryNamespace["CONVERSATIONS_WAP"] = "conversation-wap";
    CategoryNamespace["CARRIER_FEE"] = "carrier-fee";
    CategoryNamespace["USER"] = "user";
    CategoryNamespace["IDENTIFIER"] = "identifier";
    CategoryNamespace["STORAGE_GENERAL"] = "storage-general";
    CategoryNamespace["STORAGE_WEAVIATE"] = "storage-weaviate";
    CategoryNamespace["PRODUCT"] = "product";
})(CategoryNamespace || (CategoryNamespace = {}));
//# sourceMappingURL=category-namespace.js.map